import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'components/common/modal';

import { closeModal } from 'features/modalSlice';
import { setSelectedCancellationAndPaymentPolicyData } from 'features/userSlice';

import './CancellationAndPaymentPolicyModal.css';

const CancellationAndPaymentPolicyModal = ({ title }) => {
    const dispatch = useDispatch();

    const { isCancellationAndPaymentPolicyModalOpen } = useSelector(
        (state) => state.modal
    );

    const cancellationAndPaymentPolicyData = useSelector(
        (state) => state.user?.selectedCancellationAndPaymentPolicyData
    );

    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const modalTitle =
        cancellationAndPaymentPolicyData?.modalTitle ||
        Lang?.cancellationAndPaymentOptions ||
        'Cancellation and payment options';
    const handleModalClose = () => {
        dispatch(closeModal({ modalId: 'CancellationAndPaymentPolicyModal' }));
        dispatch(setSelectedCancellationAndPaymentPolicyData(null));
    };

    const renderContent = () => {
        return (
            <div className="ab-cancellation-policy-cnt">
                <div className="ab-modaltext">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: cancellationAndPaymentPolicyData?.modalContent,
                        }}
                    ></div>

                    <h4>
                        {
                            cancellationAndPaymentPolicyData?.cancellationPolicyType
                        }
                    </h4>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: cancellationAndPaymentPolicyData?.cancellationPolicy,
                        }}
                    ></div>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: cancellationAndPaymentPolicyData?.cancellationPenalty,
                        }}
                    ></div>
                </div>
                {cancellationAndPaymentPolicyData?.paymentPolicy && (
                    <div>
                        <h4>{Lang?.paymentPolicy}</h4>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: cancellationAndPaymentPolicyData?.paymentPolicy,
                            }}
                        ></div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <Modal
            className="ab-modal--cancellation-policy"
            isOpen={isCancellationAndPaymentPolicyModalOpen}
            onClose={handleModalClose}
            onOverlayClick={handleModalClose}
            placement="center"
            renderContent={renderContent}
            title={modalTitle}
            width={700}
        />
    );
};
CancellationAndPaymentPolicyModal.propTypes = {
    title: PropTypes.string,
};

export default CancellationAndPaymentPolicyModal;
